export const revokeApiKeyAction = 'revokeApiKeyAction';
export const openApiKeyCreateModalAction = 'openApiKeyCreateModalAction';
export const openApiKeyRevealModalAction = 'openApiKeyRevealModalAction';
export const closeApiKeyRevealModalAction = 'closeApiKeyRevealModalAction';
export const openApiKeyRevokeModalAction = 'openApiKeyRevokeModalAction';
export const closeApiKeyRevokeModalAction = 'closeApiKeyRevokeModalAction';
